define.alias("shared/components/shared/mavely/links/select-modal", "settings/components/shared/mavely/links/select-modal");